import {
  createContext, useContext, useState, useMemo, useCallback,
} from 'react';
import PropTypes from 'prop-types';

const TransactionContext = createContext();

function TransactionProvider({ children }) {
  const [cart, setCart] = useState([]);

  const addItem = useCallback((item) => {
    setCart((currentCart) => {
      // Check if item already exists in cart
      const existingItem = currentCart.find((cartItem) => cartItem.id === item.id);
      if (existingItem) {
        // If exists, increase quantity
        return currentCart.map((cartItem) => (cartItem.id === item.id
          ? { ...cartItem, quantity: cartItem.quantity + 1 }
          : cartItem));
      }
      // If new item, add with quantity 1
      return [...currentCart, { ...item, quantity: 1 }];
    });
  }, []);

  const removeItem = useCallback((id) => {
    setCart((currentCart) => currentCart.filter((item) => item.id !== id));
  }, []);

  // Calculate total
  const total = useMemo(
    () => cart.reduce((sum, item) => sum + (item.price * item.quantity), 0),
    [cart],
  );

  const contextValue = useMemo(() => ({
    cart,
    total,
    addItem,
    removeItem,
  }), [cart, total, addItem, removeItem]);

  return (
    <TransactionContext.Provider value={contextValue}>
      {children}
    </TransactionContext.Provider>
  );
}

TransactionProvider.propTypes = {
  children: PropTypes.node.isRequired,
};

const useTransactions = () => {
  const context = useContext(TransactionContext);
  if (!context) {
    throw new Error('useTransactions must be used within a TransactionProvider');
  }
  return context;
};

export default TransactionProvider;
export { useTransactions, TransactionContext };
